import React from "react";

export const TEST = false;
export const langs = {
  0: {'code':"de-DE", 'person': "de-DE-AmalaNeural", 'gender': "Female"},
  1: {'code':"de-DE", 'person': "de-DE-BerndNeural", 'gender': "Male"},
  2: {'code':"en-US", 'person': "en-US-AshleyNeural", 'gender': "Female"},
  3: {'code':"en-US", 'person': "en-US-BrandonNeural", 'gender': "Male"},
  4: {'code':"es-ES", 'person': "es-ES-LiaNeural", 'gender': "Female"},
  5: {'code':"es-ES", 'person': "es-ES-AlvaroNeural", 'gender': "Male"},
  6: {'code':"fr-FR", 'person': "fr-FR-BrigitteNeural", 'gender': "Female"},
  7: {'code':"fr-FR", 'person': "fr-FR-AlainNeural", 'gender': "Male"},
  8: {'code':"hu-HU", 'person': "hu-HU-NoemiNeural", 'gender': "Female"},
  9: {'code':"hu-HU", 'person': "hu-HU-TamasNeural", 'gender': "Male"},
  10: {'code':"it-IT", 'person': "it-IT-ElsaNeural", 'gender': "Female"},
  11: {'code':"it-IT", 'person': "it-IT-DiegoNeural1", 'gender': "Male"},
};
export const URL = "https://aidesk-cheppy-interface.itqs.hu";
export const postIdleTimeout = 60000; //  milliseconds (1m)
export const sessionTimeout = 3600000; //  milliseconds (1h)
export const showErrorMessageTimeout = 3000; //  milliseconds (4s)
export const logPrefix = "[AI-Desk chat] ";
export function timestampToTime(timestamp) {
  // Create a new Date object from the timestamp (in milliseconds)
  const date = new Date(timestamp);

  // Extract hours, minutes, and seconds
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  // Return the time in HH:MM:SS format
  return `${hours}:${minutes}:${seconds}`;
}
export const errorHandler = (error, Logout) => {
  console.log(logPrefix + "NETWORK ERROR");
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  console.log(error.config);
  Logout();
}

const fileTypes = ["MP3", "MP4"];
export const CQI = {
  'TEST': false,
  'logPrefix': "[AI-Desk CQI] ",
  'URL': "https://aidesk-cheppy-interface.itqs.hu",
  'testURL': "/fake_inspect_call",
  'fileTypes': fileTypes,
  'dropAreaInitText': <div className={"inside"}>
    <p>Drop here the file to upload!</p>
    <p className={"file-types"}>
      {(fileTypes.map((v) => {return v + ' ' }))}
    </p>
  </div>,
  'questions': [
    'Az ügyintéző megfelelően köszönti az ügyfelet?',
    'Az ügyintéző megkérdezte-e a hívás elején, hogy miben segíthet?',
    'Bemutatkozik az ügyintéző a hívás elején?',
    'Az ügyintéző a hívás végén megköszöni-e a hívást az ügyfélnek?',
    'Az ügyintéző megfelően elköszön-e?',
    'Az ügyintéző említi az adószámot és a képviselt cég nevét?',
    'Az ügyintéző megfelelően megkísérli azonosítani az ügyfelet?',
    'Az ügyintéző megfelelően végzi az adategyeztetést?',
    'Az ügyintéző kitért a tartozás ellenörzésére?',
    'Van e arra utaló jel, hogy az ügyintéző megekereste az ügyfél kommunikáció előzményeit?',
    'Elhangzik minden fontos információ?',
    'Az ügyintéző a tájékoztatást megfelelő magabiztossággal adta át az ügyfélnek?',
    'Az ügyintéző türelmesen kezelte a hívást, az ügyfél szavába vágott?',
    'Az ügyintéző használt irányított kérdéseket a pontosítás miatt?',
    'Az ügyintéző tartotta az aktuális témát a hívás során vagy több téma is felmerült?',
    'Az ügyintéző figyel az ügyfél mondandójára, minden felvetésre választ ad?',
    'Az ügyintéző érthetően fogalmaz?',
    'Az ügyintéző pozitív stílusban fogalmaz?',
    'Az ügyintéző üzleties stílusban fogalmaz, udvarias, magázódik?',
    'Az ügyintéző alkalmazkodik az ügyfél kommunikációs stílusához?',
    'Az ügyintéző szabályszerűen várakoztatja az ügyfelet?',
    'Az ügyintéző indokoltan várakoztatja az ügyfelet?',
    'Az ügyintéző szükség esetén ígér visszahívást az ügyfélnek?',
    'Ha az ügyfélnek vannak negatív visszajelzései, akkor az ügyintéző megpróbálja a negatív visszajelzéseket megoldani?',
    'Az ügyintéző hitelesen képviselte a céget?',
    'Az ügyintéző megfelelően kezelte a kifogásokat?',
    'Az ügyintéző szükség esetén elnézést kért az ügyféltől?',
    'Az ügyintéző adott általános javaslatokat, tanácsokat az ügyfélnek?',
    "Az ügyintéző említi a 'Segíthetek-e még valamiben' kérdést?",

    "Az ügyintéző megfelelően köszönti az ügyfelet? Napszaknak megfelelő köszönés: Jó reggelt, Jó napot, Jó estét kíván-e az ügyfélnek?",
    "Az ügyintéző elmondta-e a képviselt cég nevét, illetve a saját nevét?",
    "Az ügyintéző megkérdezte-e a hívás elején, hogy miben segíthet?",
    "Az ügyintéző a hívás végén megköszöni-e a hívást az ügyfélnek?",
    "Az ügyintéző megfelően elköszön-e? Példa: 'Köszönjük a hívását! Viszont hallásra!'",
    "A tájékoztatást megfelelő magabiztossággal adta át az ügyfélnek? Az ügyfél nem bizonytalanodott el a hívás végén?",
    "Az ügyintéző nem dadogott, nem használt-e nem protokolláris kifejezéseket?",
    "Az ügyintéző, udvarias, és előzékeny maradt az ügyféllel, végig figyelt, és komolyan vette amit mond?",
    "Az ügyintéző végig az ügyfél számára legmegfelelőbb megoldásra törekedett? Igyekezett, hogy az ügyfélnek minél kevesebb további teendője legyen az ügymenettel kapcsolatban? Felajánl e visszahívást szükség esetén, vagy továbbítja helyette a problémát?",
    "Az ügyintéző nem véleményezte negatívan  a céget, vagy annak eljárási rendjét? Nem minősítette a cég eszközeit, felületeit? Elmagyarázza e az eljárás miértjét, ha szükséges?",
    "Az ügyfél megoldást kap-e a felmerülő problémájára, illetve legalább tisztában van azzal, hogy mi a következő lépés az ügymenet megoldására?",
    "Az ügyintéző a feltett kérdésekre ad választ, illetve pontosító kérdéseket tesz-e fel, hogy megértse az ügyfél problémáját? Amennyiben utánanézés szükséges, kéri-e türelmét az ügyfélnek? Időnként jelzi e az ügyfélnek, hogy vonalban van még, csak keresi a megoldást a problémára?",
    "1-től 10-ig terjedő skálán mennyire voltak szemantikailag megfelelőek az ügyintéző mondatai?",
],
  'fakeData': {
    'source': '2024-02-01-08-16_dolakalexandra_36303789926_3615774664_Sikeresen_lezart.mp4',
    'phrases': [
      {
        'id': 0,
        'text': 'Köszönjük, hogy hívott bennünket a jogszabályok miatt. A beszélgetés rögzítésre kerül, máris kapcsoljuk kollégánkat, aki azonnal segít önnek.',
        'sentiment': {
          'neutral': 0.17,
          'negative': 0,
          'positive': 0.8300000000000001
        },
        'confidence': 0.7627357,
        'speaker_number': 0
      },
      {
        'id': 1,
        'text': 'Keresztanyja vagyok miben segíthetek önnek?',
        'sentiment': {'neutral': 0.39, 'negative': 0, 'positive': 0.61},
        'confidence': 0.74484915,
        'speaker_number': 0
      },
      {
        'id': 2,
        'text': 'Jó napot kívánok.',
        'sentiment': {'neutral': 0.15, 'negative': 0, 'positive': 0.85},
        'confidence': 0.74484915,
        'speaker_number': 1
      },
      {
        'id': 3,
        'text': 'Szent istvánról egyéni vállalkozó is van önöknél egy ország terminál, amit én használok már régóta is.',
        'sentiment': {'neutral': 0.95, 'negative': 0.02, 'positive': 0.03},
        'confidence': 0.7202859,
        'speaker_number': 1
      },
      {
        'id': 4,
        'text': 'Tegnapelőtt volt egy olyan.',
        'sentiment': {'neutral': 1, 'negative': 0, 'positive': 0},
        'confidence': 0.72873867,
        'speaker_number': 1
      },
      {
        'id': 5,
        'text': 'Problémánk, hogy a vevő.',
        'sentiment': {'neutral': 0.07, 'negative': 0.93, 'positive': 0},
        'confidence': 0.6660418,
        'speaker_number': 1
      },
      {
        'id': 6,
        'text': 'Kártyák óra perces kártyával fizetett az 1. Fizetéstől sikertelen volt.',
        'sentiment': {'neutral': 0.405, 'negative': 0.59, 'positive': 0.005},
        'confidence': 0.6232737,
        'speaker_number': 1
      },
      {
        'id': 7,
        'text': 'Akkor én újra próbálkoztam az érvényesnek és utána ő visszajött reklamálni, hogy 2 vonta le a kártyájáról az összeget. A terminál viszont én csak egy kaptam meg.',
        'sentiment': {'neutral': 0.39, 'negative': 0.6, 'positive': 0},
        'confidence': 0.67377025,
        'speaker_number': 1
      },
      {
        'id': 8,
        'text': 'És emiatt be is telefonáltam.',
        'sentiment': {'neutral': 0.99, 'negative': 0.01, 'positive': 0},
        'confidence': 0.77079254,
        'speaker_number': 1
      },
      {
        'id': 9,
        'text': 'Nos feléjük rendezték, mert látom, hogy el van nekik küldve a.',
        'sentiment': {},
        'confidence': 0.6621903,
        'speaker_number': 1
      },
      {
        'id': 10,
        'text': 'Bizonyos összeg a.',
        'sentiment': {},
        'confidence': 0.73849624,
        'speaker_number': 1
      }, {
        'id': 11,
        'text': 'Sikertelen tranzakció rendezése címen viszont én nem kaptam meg, tehát így nekem hétezer négyszázötvenöt forinttal kevesebb a.',
        'sentiment': {},
        'confidence': 0.6417211,
        'speaker_number': 1
      }, {
        'id': 12,
        'text': 'Utalások hát tőlük Péter vonta le ők megkapták a.',
        'sentiment': {},
        'confidence': 0.59844047,
        'speaker_number': 1
      }, {
        'id': 13,
        'text': 'Ugye az összeget, amivel igazából be lettek csapva, bár nem én csaptam be őket. Viszont így nekem a terhelés miatt nincs meg ez az.',
        'sentiment': {'neutral': 0.85, 'negative': 0.14, 'positive': 0},
        'confidence': 0.75082606,
        'speaker_number': 1
      }, {
        'id': 14,
        'text': 'Összeg ez.',
        'sentiment': {'neutral': 0.88, 'negative': 0.05, 'positive': 0.08},
        'confidence': 0.75082606,
        'speaker_number': 0
      }, {
        'id': 15,
        'text': 'Mikor várható hogy jóvá?',
        'sentiment': {'neutral': 0.94, 'negative': 0.01, 'positive': 0.05},
        'confidence': 0.75082606,
        'speaker_number': 1
      }, {
        'id': 16,
        'text': 'Egy kis türelmét annak utána kell, hogy nézzek. Szeretnék kérni öntől egységes adószámot.',
        'sentiment': {'neutral': 0.51, 'negative': 0.015, 'positive': 0.475},
        'confidence': 0.7311658,
        'speaker_number': 0
      }, {
        'id': 17,
        'text': 'Hatvankilenc huszonnégy ötvenhat 20- 2-',
        'sentiment': {},
        'confidence': 0.61315584,
        'speaker_number': 1
      }, {'id': 18, 'text': 'Tehát- 2-', 'sentiment': {}, 'confidence': 0.6111578, 'speaker_number': 0}, {
        'id': 19,
        'text': 'Köszönöm szépen az ön teljes nevét, hogy kérjem el.',
        'sentiment': {},
        'confidence': 0.7913467,
        'speaker_number': 0
      }, {
        'id': 20,
        'text': 'Fazekasné besenyei csilla klára.',
        'sentiment': {'neutral': 0.91, 'negative': 0.03, 'positive': 0.06},
        'confidence': 0.60466474,
        'speaker_number': 1
      }, {
        'id': 21,
        'text': 'Mikor és hol született?',
        'sentiment': {'neutral': 0.98, 'negative': 0.01, 'positive': 0.01},
        'confidence': 0.60466474,
        'speaker_number': 0
      }, {
        'id': 22,
        'text': 'Mikort ezerkilencszázhetvenkettő 10. hó huszonnyolc.',
        'sentiment': {'neutral': 0.96, 'negative': 0.01, 'positive': 0.03},
        'confidence': 0.6241649,
        'speaker_number': 1
      }, {
        'id': 23,
        'text': 'Édesanyja, leánykori neve.',
        'sentiment': {'neutral': 0.4, 'negative': 0.01, 'positive': 0.59},
        'confidence': 0.6241649,
        'speaker_number': 0
      }, {
        'id': 24,
        'text': 'Jelképet?',
        'sentiment': {'neutral': 0.98, 'negative': 0.02, 'positive': 0},
        'confidence': 0.25351226,
        'speaker_number': 1
      }, {
        'id': 25,
        'text': 'Köszönöm szépen.',
        'sentiment': {'neutral': 0.015, 'negative': 0, 'positive': 0.985},
        'confidence': 0.8055112,
        'speaker_number': 0
      }, {
        'id': 26,
        'text': 'Egy egy.',
        'sentiment': {'neutral': 0.96, 'negative': 0.01, 'positive': 0.04},
        'confidence': 0.7987949,
        'speaker_number': 1
      }, {
        'id': 27,
        'text': 'Ugyanígy volt minden hónapra.',
        'sentiment': {'neutral': 0.97, 'negative': 0, 'positive': 0.03},
        'confidence': 0.60604936,
        'speaker_number': 1
      }, {
        'id': 28,
        'text': 'Fog menni.',
        'sentiment': {'neutral': 0.94, 'negative': 0.01, 'positive': 0.05},
        'confidence': 0.6514474,
        'speaker_number': 1
      }, {
        'id': 29,
        'text': 'Egy kis türelmét hogy kérjen.',
        'sentiment': {'neutral': 0.94, 'negative': 0, 'positive': 0.05},
        'confidence': 0.7427499,
        'speaker_number': 0
      }, {
        'id': 30,
        'text': 'Mikor történt ez a tranzakcióban? Segítsen nekem.',
        'sentiment': {'neutral': 0.72, 'negative': 0.035, 'positive': 0.25},
        'confidence': 0.61691254,
        'speaker_number': 0
      }, {
        'id': 31,
        'text': 'Mondja hogy.',
        'sentiment': {'neutral': 0.92, 'negative': 0.02, 'positive': 0.07},
        'confidence': 0.76915747,
        'speaker_number': 1
      }, {'id': 32, 'text': 'Helyszín.', 'sentiment': {}, 'confidence': 0.3934235, 'speaker_number': 1}, {
        'id': 33,
        'text': '30.',
        'sentiment': {},
        'confidence': 0.5575593,
        'speaker_number': 0
      }, {'id': 34, 'text': 'Igen 30.', 'sentiment': {}, 'confidence': 0.62883323, 'speaker_number': 1}, {
        'id': 35,
        'text': 'Köszönöm.',
        'sentiment': {},
        'confidence': 0.62883323,
        'speaker_number': 0
      }, {'id': 36, 'text': 'Rába kerülni?', 'sentiment': {}, 'confidence': 0.45423874, 'speaker_number': 1}, {
        'id': 37,
        'text': 'Nem próbáltak így aztán előtt.',
        'sentiment': {'neutral': 1, 'negative': 0, 'positive': 0},
        'confidence': 0.5571619,
        'speaker_number': 1
      }, {
        'id': 38,
        'text': 'Számlavezetési díj termelőknek.',
        'sentiment': {'neutral': 0.73, 'negative': 0.08, 'positive': 0.18},
        'confidence': 0.2674314,
        'speaker_number': 1
      }, {
        'id': 39,
        'text': 'Nem a saját, hanem.',
        'sentiment': {'neutral': 0.89, 'negative': 0.1, 'positive': 0.01},
        'confidence': 0.84587765,
        'speaker_number': 1
      }, {
        'id': 40,
        'text': 'Mivel föld hónap.',
        'sentiment': {},
        'confidence': 0.6019908,
        'speaker_number': 1
      }, {
        'id': 41,
        'text': '5 hónapja nem fog fizetni.',
        'sentiment': {},
        'confidence': 0.7560832,
        'speaker_number': 1
      }, {
        'id': 42,
        'text': 'Kényelmes szépen nem akarnak belépni.',
        'sentiment': {'neutral': 0.05, 'negative': 0.01, 'positive': 0.94},
        'confidence': 0.65829927,
        'speaker_number': 0
      }, {
        'id': 43,
        'text': 'Kis türelmet hadd kérjem kérem addig tartsa a neved zenét fog hallani. Köszönöm szépen.',
        'sentiment': {'neutral': 0.2366666666666667, 'negative': 0.006666666666666667, 'positive': 0.7533333333333333},
        'confidence': 0.7624181,
        'speaker_number': 0
      }, {'id': 44, 'text': 'Br.', 'sentiment': {}, 'confidence': 0.6356921, 'speaker_number': 0}, {
        'id': 45,
        'text': 'A.',
        'sentiment': {},
        'confidence': 0.9002432,
        'speaker_number': 0
      }, {
        'id': 46,
        'text': 'Köszönöm szépen. Ez mekkora összegről van szó.',
        'sentiment': {'neutral': 0.33, 'negative': 0.003333333333333334, 'positive': 0.6633333333333333},
        'confidence': 0.803182,
        'speaker_number': 0
      }, {
        'id': 47,
        'text': 'Ez pontosan hétezer négyszázötvenöt forint.',
        'sentiment': {'neutral': 0.99, 'negative': 0.01, 'positive': 0},
        'confidence': 0.6535396,
        'speaker_number': 1
      }, {
        'id': 48,
        'text': 'És biztosan 30. történt a tranzakció.',
        'sentiment': {'neutral': 0.98, 'negative': 0.02, 'positive': 0},
        'confidence': 0.7207755,
        'speaker_number': 0
      }, {'id': 49, 'text': 'Igen.', 'sentiment': {}, 'confidence': 0.8825165, 'speaker_number': 1}, {
        'id': 50,
        'text': 'Illetve az a tranzakció ami sikertelen volt és 2 került levonásra a vevőtől 29.',
        'sentiment': {},
        'confidence': 0.74325323,
        'speaker_number': 1
      }, {
        'id': 51,
        'text': 'És akkor másnap bejött reklamálni 30. és akkor már az én számlámról önök átutalták neki. Tehát ez ennyi, mert.',
        'sentiment': {'neutral': 0.97, 'negative': 0.02, 'positive': 0.01},
        'confidence': 0.66807675,
        'speaker_number': 1
      }, {
        'id': 52,
        'text': 'Látom, hogy önnél jóvá jóváírásra kerül, tehát való igaz, hogy volt egy elutasított tranzakció.',
        'sentiment': {},
        'confidence': 0.66807675,
        'speaker_number': 0
      }, {
        'id': 53,
        'text': '29. 9:08 perckor majd 40 másodperccel később lett sikeres a tranzakció.',
        'sentiment': {'neutral': 0.52, 'negative': 0.02, 'positive': 0.45},
        'confidence': 0.80063266,
        'speaker_number': 0
      }, {
        'id': 54,
        'text': 'Igen de nekem egy lett jóvá írva.',
        'sentiment': {'neutral': 1, 'negative': 0, 'positive': 0},
        'confidence': 0.68714577,
        'speaker_number': 1
      }, {
        'id': 55,
        'text': 'Egy itt van előttem.',
        'sentiment': {'neutral': 0.99, 'negative': 0, 'positive': 0.01},
        'confidence': 0.65973634,
        'speaker_number': 1
      }, {
        'id': 56,
        'text': 'De nyilván egy írva, hiszen egy elutasításra került egy pedig ugye sikeres volt egy nyilván egy a hetes 1 000 négyszázötvenöt forintot fogja megkapni.',
        'sentiment': {'neutral': 0.02, 'negative': 0.98, 'positive': 0.01},
        'confidence': 0.65973634,
        'speaker_number': 0
      }, {
        'id': 57,
        'text': 'Igen de ezt a 7 hétezer négyszázötvenöt forintot utána másnap elutalták kálmán boglárka részére, merthogy ő tőle meg 2 vonta le én egy megkaptam azt önök utána átutalták kálmán boglárkának, tehát igazából én nem kaptam meg.',
        'sentiment': {'neutral': 0.88, 'negative': 0.11, 'positive': 0.02},
        'confidence': 0.60080063,
        'speaker_number': 1
      }, {
        'id': 58,
        'text': 'Engem állítom, hogy.',
        'sentiment': {'neutral': 0.98, 'negative': 0.01, 'positive': 0.01},
        'confidence': 0.6377917,
        'speaker_number': 1
      }, {
        'id': 59,
        'text': 'Megkapta, hogy jóváírásra kerül.',
        'sentiment': {'neutral': 0.87, 'negative': 0.04, 'positive': 0.1},
        'confidence': 0.6377917,
        'speaker_number': 0
      }, {
        'id': 60,
        'text': 'Jóváírásra került nekem 1. 30. pár.',
        'sentiment': {},
        'confidence': 0.6377917,
        'speaker_number': 1
      }, {'id': 61, 'text': '16 ft.', 'sentiment': {}, 'confidence': 0.6377917, 'speaker_number': 0}, {
        'id': 62,
        'text': 'Tranzakció rendezés.',
        'sentiment': {'neutral': 0.78, 'negative': 0.02, 'positive': 0.19},
        'confidence': 0.5186977,
        'speaker_number': 1
      }, {
        'id': 63,
        'text': 'És terhelés pedig hétezer négyszázötvenöt.',
        'sentiment': {'neutral': 1, 'negative': 0, 'positive': 0},
        'confidence': 0.60094815,
        'speaker_number': 1
      }, {
        'id': 64,
        'text': 'Ez itt van előttem a vesztemet tehát.',
        'sentiment': {'neutral': 0, 'negative': 1, 'positive': 0},
        'confidence': 0.63635916,
        'speaker_number': 1
      }, {
        'id': 65,
        'text': 'Nekem azt mondta az úriember, akit aznap 30. fölhívtam, hogy egy pár nap múlva én is meg fogom majd itt a kapni ezt az összeget amit átutaltam ugye kálmán boglárkának, mert így igazából az a vásárlás nekem.',
        'sentiment': {'neutral': 0.66, 'negative': 0.27, 'positive': 0.08},
        'confidence': 0.68965966,
        'speaker_number': 1
      }, {
        'id': 66,
        'text': 'Én értem értem.',
        'sentiment': {'neutral': 0.85, 'negative': 0.04, 'positive': 0.11},
        'confidence': 0.68965966,
        'speaker_number': 0
      }, {
        'id': 67,
        'text': 'Én jóváírták tehát 16.',
        'sentiment': {},
        'confidence': 0.68965966,
        'speaker_number': 1
      }, {
        'id': 68,
        'text': 'Forint mikor beszélt kollégával?',
        'sentiment': {},
        'confidence': 0.68965966,
        'speaker_number': 0
      }, {
        'id': 69,
        'text': '30. és még aznap át is utalták ennek AA vásárlónak.',
        'sentiment': {},
        'confidence': 0.68965966,
        'speaker_number': 1
      }, {
        'id': 70,
        'text': 'Tehát nem csak ugye kolléga jelezte ön felé, hogy azt az összeget meg fogja kapni, tehát ennek egy picit több az átfutási ideje.',
        'sentiment': {'neutral': 0.92, 'negative': 0.08, 'positive': 0.01},
        'confidence': 0.68965966,
        'speaker_number': 0
      }, {
        'id': 71,
        'text': 'Tehát mindenféleképpen jóváírásra fog ennél is kerülni. Ez a hetes 1 000 négyszázötvenöt forint.',
        'sentiment': {'neutral': 0.75, 'negative': 0.24, 'positive': 0.01},
        'confidence': 0.7008736,
        'speaker_number': 0
      }, {
        'id': 72,
        'text': 'De akkor még most.',
        'sentiment': {'neutral': 0.99, 'negative': 0.01, 'positive': 0},
        'confidence': 0.7008736,
        'speaker_number': 1
      }, {
        'id': 73,
        'text': 'Még nem, nem ez még nem történt meg.',
        'sentiment': {'neutral': 0.98, 'negative': 0.02, 'positive': 0},
        'confidence': 0.7008736,
        'speaker_number': 0
      }, {
        'id': 74,
        'text': 'Nem tehát az.',
        'sentiment': {'neutral': 0.88, 'negative': 0.11, 'positive': 0},
        'confidence': 0.8066225,
        'speaker_number': 1
      }, {
        'id': 75,
        'text': 'Ügyfél felé nyilván ez előbb történik meg, mármint, hogy az ön ügyfele felé. Tehát, hogy nem tudom igen, tehát, hogy ebből ne legyen probléma, tehát ezt meg fogja kapni mindenképpen.',
        'sentiment': {'neutral': 0.725, 'negative': 0.215, 'positive': 0.06},
        'confidence': 0.8066225,
        'speaker_number': 0
      }, {
        'id': 76,
        'text': 'Jó rendben. Köszönöm a.',
        'sentiment': {'neutral': 0.03, 'negative': 0, 'positive': 0.97},
        'confidence': 0.7339373,
        'speaker_number': 1
      }, {
        'id': 77,
        'text': 'Figyelmet a hívását szép napot önnek vele viszont hallásra.',
        'sentiment': {},
        'confidence': 0.7339373,
        'speaker_number': 0
      }],
    'quality': [
      {
        'Answer': '1',
        'Question': 'Az ügyintéző megfelelően köszönti az ügyfelet?',
        'Justification': 'Az ügyintéző a beszélgetés elején köszön a hívó félnek.'
      },
      {
        'Answer': '1',
        'Question': 'Az ügyintéző megkérdezte-e a hívás elején, hogy miben segíthet?',
        'Justification': 'Az ügyintéző megkérdezi az ügyfelet, hogy miben segíthet.'
      },
      {
        'Answer': '0',
        'Question': 'Bemutatkozik az ügyintéző a hívás elején?',
        'Justification': 'Az ügyintéző nem mutatkozik be a hívás elején.'
      },
      {
        'Answer': '1',
        'Question': 'Az ügyintéző a hívás végén megköszöni-e a hívást az ügyfélnek?',
        'Justification': 'Az ügyintéző a hívás végén megköszöni a hívást az ügyfélnek.'
      },
      {
        'Answer': '1',
        'Question': 'Az ügyintéző megfelően elköszön-e?',
        'Justification': 'Az ügyintéző megfelelően elköszön az ügyféllel.'
      },
      {
        'Answer': '0',
        'Question': 'Az ügyintéző említi az adószámot és a képviselt cég nevét?',
        'Justification': 'Az ügyintéző nem említi az adószámot és a képviselt cég nevét.'
      },
      {
        'Answer': '3',
        'Question': 'Az ügyintéző megfelelően megkísérli azonosítani az ügyfelet?',
        'Justification': 'Az ügyintéző megkérdezi az ügyfelet az édesanyja nevéről és a születési helyéről, majd közli, hogy az azonosítás sikeres volt.'
      },
      {
        'Answer': '2',
        'Question': 'Az ügyintéző megfelelően végzi az adategyeztetést?',
        'Justification': 'Az ügyintéző nem közli az ügyféllel, hogy változott valamilyen ügyféladat.'
      }, {
        'Answer': '4',
        'Question': 'Az ügyintéző kitért a tartozás ellenörzésére?',
        'Justification': 'Az ügyintéző megkérdezi az ügyfelet a tartozásról és közli, hogy az ügyfélnek jóváírásra kerül.'
      }, {
        'Answer': '0',
        'Question': 'Van e arra utaló jel, hogy az ügyintéző megekereste az ügyfél kommunikáció előzményeit?',
        'Justification': 'Nincs arra utaló jel, hogy az ügyintéző megnézte volna az ügyfél korábbi kommunikációját.'
      }, {
        'Answer': '10',
        'Question': 'Elhangzik minden fontos információ?',
        'Justification': 'Az ügyintéző minden fontos információt közöl az ügyféllel.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző a tájékoztatást megfelelő magabiztossággal adta át az ügyfélnek?',
        'Justification': 'Az ügyintéző magabiztosan és határozottan közli az információkat az ügyféllel.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző türelmesen kezelte a hívást, az ügyfél szavába vágott?',
        'Justification': 'Az ügyintéző türelmesen kezeli a hívást és nem szakítja félbe az ügyfelet.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző használt irányított kérdéseket a pontosítás miatt?',
        'Justification': 'Az ügyintéző használ irányított kérdéseket a pontosítás érdekében.'
      }, {
        'Answer': '0',
        'Question': 'Az ügyintéző tartotta az aktuális témát a hívás során vagy több téma is felmerült?',
        'Justification': 'Az ügyintéző nem tartotta az aktuális témát a hívás során, több téma is felmerült.'
      }, {
        'Answer': '3',
        'Question': 'Az ügyintéző figyel az ügyfél mondandójára, minden felvetésre választ ad?',
        'Justification': 'Az ügyintéző figyel az ügyfél mondandójára és válaszol a felvetésekre, de nem minden esetben ad választ.'
      }, {
        'Answer': '2',
        'Question': 'Az ügyintéző érthetően fogalmaz?',
        'Justification': 'Az ügyintéző érthetően fogalmaz, de néhány esetben nehezen érthető.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző pozitív stílusban fogalmaz?',
        'Justification': 'Az ügyintéző pozitív stílusban fogalmaz.'
      }, {
        'Answer': '3',
        'Question': 'Az ügyintéző üzleties stílusban fogalmaz, udvarias, magázódik?',
        'Justification': 'Az ügyintéző üzleties stílusban fogalmaz, udvarias és magázódik.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző alkalmazkodik az ügyfél kommunikációs stílusához?',
        'Justification': 'Az ügyintéző alkalmazkodik az ügyfél kommunikációs stílusához.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző szabályszerűen várakoztatja az ügyfelet?',
        'Justification': 'Az ügyintéző szabályszerűen várakoztatja az ügyfelet.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző indokoltan várakoztatja az ügyfelet?',
        'Justification': 'Az ügyintéző indokoltan várakoztatja az ügyfelet.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző szükség esetén ígér visszahívást az ügyfélnek?',
        'Justification': 'Az ügyintéző szükség esetén ígér visszahívást az ügyfélnek.'
      }, {
        'Answer': '1',
        'Question': 'Ha az ügyfélnek vannak negatív visszajelzései, akkor az ügyintéző megpróbálja a negatív visszajelzéseket megoldani?',
        'Justification': 'Az ügyintéző megpróbálja megoldani az ügyfél negatív visszajelzéseit.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző hitelesen képviselte a céget?',
        'Justification': 'Az ügyintéző hitelesen képviseli a céget.'
      }, {
        'Answer': '1',
        'Question': 'Az ügyintéző megfelelően kezelte a kifogásokat?',
        'Justification': 'Az ügyintéző megfelelően kezeli a kifogásokat.'
      }, {
        'Answer': '0',
        'Question': 'Az ügyintéző szükség esetén elnézést kért az ügyféltől?',
        'Justification': 'Az ügyintéző nem kért elnézést az ügyféltől.'
      }, {
        'Answer': '0',
        'Question': 'Az ügyintéző adott általános javaslatokat, tanácsokat az ügyfélnek?',
        'Justification': 'Az ügyintéző nem adott általános javaslatokat vagy tanácsokat az ügyfélnek.'
      }, {
        'Answer': '0',
        'Question': "Az ügyintéző említi a 'Segíthetek-e még valamiben' kérdést?",
        'Justification': "Az ügyintéző nem említi a 'Segíthetek-e még valamiben' kérdést."
      }],
    'total_sentiment': {'neutral': 0.13, 'negative': 0.36, 'positive': 0.51},
    'total_confidence': 0.6743809161538461
  },
  'fakeData2': {
    "metadata": {
      "trace_id": "f32a132f-830b-4def-9620-2844a07853f3"
    },
    "output": "{'source': 'upload-9833293715815076220Budapest_Park_2023-05-04-14-22_kovacskrisztian_3614347800_3617664552_Sikeres.mp4', 'phrases': [{'id': 0, 'text': 'Jó napot kívánok Budapest park kovács krisztina vagyok én nem tudok önnek segíteni.', 'confidence': 0.7860036, 'speaker_number': 0, 'sentiment': {'positive': 0.05, 'neutral': 0.81, 'negative': 0.14}}, {'id': 1, 'text': 'Jó napot kívánok. Tóth bence vagyok. Segítséget szeretném kérni 01. 18. vásároltam egy koncertjegyet a szombati judo koncertre és kitörlődik az email jeim van arra lehetőség, hogy újra elküldték nekem ezt.', 'confidence': 0.7026128, 'speaker_number': 1, 'sentiment': {'positive': 0.49, 'neutral': 0.51, 'negative': 0.0}}, {'id': 2, 'text': 'A jegy@ Budapest park. Hu ra írja meg, hogy melyik koncertről van szó, illetve csatolja mellé valamilyen fényképes bizonyítékot arról, hogy sikerült a vásárlás. Ha megvan az a kép, ami a legvégén a huszonnégy órás felhívás után.', 'confidence': 0.7026128, 'speaker_number': 0, 'sentiment': {'positive': 0.095, 'neutral': 0.875, 'negative': 0.030000000000000002}}, {'id': 3, 'text': 'Tehát abban szokott lenni egy ilyen tranzakciós azonosító, akkor az is jó, ha csak banki oldalról van meg valami, hogy kifizette az összeget, akkor az is megfelelő, illetve azt az email címet, amire kérte a jegyeket. Gondolom lehet, hogy ezt. Egy és ugyanaz lesz mindegyiknek.', 'confidence': 0.7542605, 'speaker_number': 0, 'sentiment': {'positive': 0.495, 'neutral': 0.505, 'negative': 0.0}}, {'id': 4, 'text': 'Akkor kiküldik önöknek újra?', 'confidence': 0.5658147, 'speaker_number': 0, 'sentiment': {'positive': 0.0, 'neutral': 0.99, 'negative': 0.01}}, {'id': 5, 'text': 'Jó rendben. Köszönöm szépen a segítséget.', 'confidence': 0.7364266, 'speaker_number': 1, 'sentiment': {'positive': 0.93, 'neutral': 0.06, 'negative': 0.0}}, {'id': 6, 'text': 'Nincs mit viszonthallásra.', 'confidence': 0.7364266, 'speaker_number': 0, 'sentiment': {'positive': 0.02, 'neutral': 0.4, 'negative': 0.58}}, {'id': 7, 'text': 'Viszonthallásra.', 'confidence': 0.7364266, 'speaker_number': 1, 'sentiment': {'positive': 0.5, 'neutral': 0.47, 'negative': 0.03}}], 'total_sentiment': {'positive': 0.74, 'neutral': 0.17, 'negative': 0.09}, 'total_confidence': 0.7150730249999999, 'quality': [{'Question': 'Az ügyintéző megfelelően köszönti az ügyfelet?', 'Answer': '1', 'Justification': 'Az ügyintéző minden esetben megfelelően köszönti az ügyfelet a napszaknak megfelelően.'}, {'Question': 'Az ügyintéző elmondta-e a képviselt cég nevét, illetve a saját nevét?', 'Answer': '0', 'Justification': 'Az ügyintéző nem mondja el a képviselt cég nevét és a saját nevét.'}, {'Question': 'Az ügyintéző megkérdezte-e a hívás elején, hogy miben segíthet?', 'Answer': '1', 'Justification': 'Az ügyintéző minden esetben megkérdezi a hívás elején, hogy miben segíthet.'}, {'Question': 'Az ügyintéző a hívás végén megköszöni-e a hívást az ügyfélnek?', 'Answer': '0', 'Justification': 'Az ügyintéző nem köszöni meg a hívást az ügyfélnek.'}, {'Question': 'Az ügyintéző megfelően elköszön-e?', 'Answer': '1', 'Justification': 'Az ügyintéző megfelelően elköszön az ügyféllel.'}, {'Question': 'A tájékoztatást megfelelő magabiztossággal adta át az ügyfélnek?', 'Answer': '2', 'Justification': 'Az ügyintéző magabiztosan adja át a tájékoztatást az ügyfélnek, aki nem bizonytalanodik el a hívás végén.'}, {'Question': 'Az ügyintéző nem dadogott, nem használt-e nem protokolláris kifejezéseket?', 'Answer': '2', 'Justification': 'Az ügyintéző nem dadog és nem használ nem protokolláris kifejezéseket.'}, {'Question': 'Az ügyintéző, udvarias, és előzékeny maradt az ügyféllel, végig figyelt, és komolyan vette amit mond?', 'Answer': '2', 'Justification': 'Az ügyintéző udvarias és előzékeny marad az ügyféllel, végig figyel és komolyan veszi amit mond.'}, {'Question': 'Az ügyintéző végig az ügyfél számára legmegfelelőbb megoldásra törekedett?', 'Answer': '4', 'Justification': 'Az ügyintéző mindig az ügyfél számára legmegfelelőbb megoldásra törekszik, felajánlja a visszahívást és továbbítja a problémát.'}, {'Question': 'Az ügyintéző nem véleményezte negatívan a céget, vagy annak eljárási rendjét?', 'Answer': '2', 'Justification': 'Az ügyintéző nem véleményezi negatívan a céget vagy annak eljárási rendjét, és elmagyarázza az eljárás miértjét, ha szükséges.'}, {'Question': 'Az ügyfél megoldást kap-e a felmerülő problémájára, illetve legalább tisztában van azzal, hogy mi a következő lépés az ügymenet megoldására?', 'Answer': '4', 'Justification': 'Az ügyfél megoldást kap a felmerülő problémájára és tisztában van azzal, hogy mi a következő lépés az ügymenet megoldására.'}, {'Question': 'Az ügyintéző a feltett kérdésekre ad választ, illetve pontosító kérdéseket tesz-e fel, hogy megértse az ügyfél problémáját?', 'Answer': '4', 'Justification': 'Az ügyintéző válaszol a feltett kérdésekre, tesz pontosító kérdéseket és kéri az ügyfél türelmét, ha utánanézés szükséges.'}, {'Question': 'Mennyire voltak szemantikailag megfelelőek az ügyintéző mondatai?', 'Answer': '8', 'Justification': 'Az ügyintéző mondatai szemantikailag nagyon megfelelőek.'}]}"
/*    "output": {
      'source': 'upload-9833293715815076220Budapest_Park_2023-05-04-14-22_kovacskrisztian_3614347800_3617664552_Sikeres.mp4',
      'phrases': [
        {'id': 0,
          'text': 'Jó napot kívánok Budapest park kovács krisztina vagyok én nem tudok önnek segíteni.',
          'confidence': 0.7860036,
          'speaker_number': 0,
          'sentiment': {
            'positive': 0.05,
            'neutral': 0.81,
            'negative': 0.14
          }
        }, {
          'id': 1,
          'text': 'Jó napot kívánok. Tóth bence vagyok. Segítséget szeretném kérni 01. 18. vásároltam egy koncertjegyet a szombati judo koncertre és kitörlődik az email jeim van arra lehetőség, hogy újra elküldték nekem ezt.',
          'confidence': 0.7026128,
          'speaker_number': 1,
          'sentiment': {'positive': 0.49, 'neutral': 0.51, 'negative': 0.0}
        }, {
          'id': 2,
          'text': 'A jegy@ Budapest park. Hu ra írja meg, hogy melyik koncertről van szó, illetve csatolja mellé valamilyen fényképes bizonyítékot arról, hogy sikerült a vásárlás. Ha megvan az a kép, ami a legvégén a huszonnégy órás felhívás után.',
          'confidence': 0.7026128,
          'speaker_number': 0,
          'sentiment': {'positive': 0.095, 'neutral': 0.875, 'negative': 0.030000000000000002}
        }, {
          'id': 3,
          'text': 'Tehát abban szokott lenni egy ilyen tranzakciós azonosító, akkor az is jó, ha csak banki oldalról van meg valami, hogy kifizette az összeget, akkor az is megfelelő, illetve azt az email címet, amire kérte a jegyeket. Gondolom lehet, hogy ezt. Egy és ugyanaz lesz mindegyiknek.',
          'confidence': 0.7542605,
          'speaker_number': 0,
          'sentiment': {'positive': 0.495, 'neutral': 0.505, 'negative': 0.0}
        }, {
          'id': 4,
          'text': 'Akkor kiküldik önöknek újra?',
          'confidence': 0.5658147,
          'speaker_number': 0,
          'sentiment': {'positive': 0.0, 'neutral': 0.99, 'negative': 0.01}
        }, {
          'id': 5,
          'text': 'Jó rendben. Köszönöm szépen a segítséget.',
          'confidence': 0.7364266,
          'speaker_number': 1,
          'sentiment': {'positive': 0.93, 'neutral': 0.06, 'negative': 0.0}
        }, {
          'id': 6,
          'text': 'Nincs mit viszonthallásra.',
          'confidence': 0.7364266,
          'speaker_number': 0,
          'sentiment': {'positive': 0.02, 'neutral': 0.4, 'negative': 0.58}
        }, {
          'id': 7,
          'text': 'Viszonthallásra.',
          'confidence': 0.7364266,
          'speaker_number': 1,
          'sentiment': {'positive': 0.5, 'neutral': 0.47, 'negative': 0.03}
        }],
      'total_sentiment': {'positive': 0.74, 'neutral': 0.17, 'negative': 0.09},
      'total_confidence': 0.7150730249999999,
      'quality': [
        {
          'Question': 'Az ügyintéző megfelelően köszönti az ügyfelet?',
          'Answer': '1',
          'Justification': 'Az ügyintéző minden esetben megfelelően köszönti az ügyfelet a napszaknak megfelelően.'
        }, {
          'Question': 'Az ügyintéző elmondta-e a képviselt cég nevét, illetve a saját nevét?',
          'Answer': '0',
          'Justification': 'Az ügyintéző nem mondja el a képviselt cég nevét és a saját nevét.'
        }, {
          'Question': 'Az ügyintéző megkérdezte-e a hívás elején, hogy miben segíthet?',
          'Answer': '1',
          'Justification': 'Az ügyintéző minden esetben megkérdezi a hívás elején, hogy miben segíthet.'
        }, {
          'Question': 'Az ügyintéző a hívás végén megköszöni-e a hívást az ügyfélnek?',
          'Answer': '0',
          'Justification': 'Az ügyintéző nem köszöni meg a hívást az ügyfélnek.'
        }, {
          'Question': 'Az ügyintéző megfelően elköszön-e?',
          'Answer': '1',
          'Justification': 'Az ügyintéző megfelelően elköszön az ügyféllel.'
        }, {
          'Question': 'A tájékoztatást megfelelő magabiztossággal adta át az ügyfélnek?',
          'Answer': '2',
          'Justification': 'Az ügyintéző magabiztosan adja át a tájékoztatást az ügyfélnek, aki nem bizonytalanodik el a hívás végén.'
        }, {
          'Question': 'Az ügyintéző nem dadogott, nem használt-e nem protokolláris kifejezéseket?',
          'Answer': '2',
          'Justification': 'Az ügyintéző nem dadog és nem használ nem protokolláris kifejezéseket.'
        }, {
          'Question': 'Az ügyintéző, udvarias, és előzékeny maradt az ügyféllel, végig figyelt, és komolyan vette amit mond?',
          'Answer': '2',
          'Justification': 'Az ügyintéző udvarias és előzékeny marad az ügyféllel, végig figyel és komolyan veszi amit mond.'
        }, {
          'Question': 'Az ügyintéző végig az ügyfél számára legmegfelelőbb megoldásra törekedett?',
          'Answer': '4',
          'Justification': 'Az ügyintéző mindig az ügyfél számára legmegfelelőbb megoldásra törekszik, felajánlja a visszahívást és továbbítja a problémát.'
        }, {
          'Question': 'Az ügyintéző nem véleményezte negatívan a céget, vagy annak eljárási rendjét?',
          'Answer': '2',
          'Justification': 'Az ügyintéző nem véleményezi negatívan a céget vagy annak eljárási rendjét, és elmagyarázza az eljárás miértjét, ha szükséges.'
        }, {
          'Question': 'Az ügyfél megoldást kap-e a felmerülő problémájára, illetve legalább tisztában van azzal, hogy mi a következő lépés az ügymenet megoldására?',
          'Answer': '4',
          'Justification': 'Az ügyfél megoldást kap a felmerülő problémájára és tisztában van azzal, hogy mi a következő lépés az ügymenet megoldására.'
        }, {
          'Question': 'Az ügyintéző a feltett kérdésekre ad választ, illetve pontosító kérdéseket tesz-e fel, hogy megértse az ügyfél problémáját?',
          'Answer': '4',
          'Justification': 'Az ügyintéző válaszol a feltett kérdésekre, tesz pontosító kérdéseket és kéri az ügyfél türelmét, ha utánanézés szükséges.'
        }, {
          'Question': 'Mennyire voltak szemantikailag megfelelőek az ügyintéző mondatai?',
          'Answer': '8',
          'Justification': 'Az ügyintéző mondatai szemantikailag nagyon megfelelőek.'
        }
      ]
    },*/
  }
};

export function setCookie(name,value,days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for(let i=0;i < ca.length;i++) {
    let c = ca[i];
    while (c.charAt(0)===' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
export function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const getREST_config = (method, bearer, multipart) => {
  let headers = {
    'Content-Type': 'application/json',
    'SameSite': 'None',
    'Secure': false
  }
  if(typeof multipart !== 'undefined' && multipart === true) {
    headers = {
      'accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'SameSite': 'None',
      'Secure': false
    }
  }

  if(typeof method === 'undefined' || method === 'login') {
    return {
      headers: headers,
    };
  }
  if(method === 'cookie' || typeof bearer === 'undefined') {
    return {
      withCredentials: true,
      headers: headers,
    }
  }
  else {
    return {
      withCredentials: true,
      headers: {
        ...headers,
        'Authorization' : "Bearer " + bearer,
      },
    };
  }

};

export const getFakeData =  async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(CQI.fakeData2);
    }, 1000);
  });
}

/*
export const swapQuotes = (str) => {
  // Use regular expressions to replace double quotes with a unique placeholder
  const stringWithSingleQuotes = str.replace(/"/g, '%QUOTES%');
  // Then, replace single quotes with double quotes and restore the original double quotes
  return stringWithSingleQuotes.replace(/'/g, '"').replace(/%QUOTES%/g, "'");
}
*/
